export const AVAILABLE_PACKAGE_KEYS = {
  PACKAGE_TYPES: 'name',
  VOLUME: 'initQuantity',
  REMAINING: 'quantity',
  PURCHASE_DATE: 'startDate',
  EXPIRY_DATE: 'endDate',
}

export const AVAILABLE_PACKAGE_TITLE = [
  {
    title: 'userManagement.availablePackage.PACKAGE_TYPES',
    key: AVAILABLE_PACKAGE_KEYS.PACKAGE_TYPES,
  },
  {
    title: 'userManagement.availablePackage.VOLUME',
    key: AVAILABLE_PACKAGE_KEYS.VOLUME,
  },
  {
    title: 'userManagement.availablePackage.REMAINING',
    key: AVAILABLE_PACKAGE_KEYS.REMAINING,
  },
  {
    title: 'userManagement.availablePackage.PURCHASE_DATE',
    key: AVAILABLE_PACKAGE_KEYS.PURCHASE_DATE,
  },
  {
    title: 'userManagement.availablePackage.EXPIRY_DATE',
    key: AVAILABLE_PACKAGE_KEYS.EXPIRY_DATE,
  },
]

export const ALL_STATUS = {
  label: 'userManagement.availablePackage.ALL',
  value: null,
  isI18n: true,
}
